import axios from '../../config/axios.js'
import store from '../../vuex/store.js'
import { addIso690 } from '../../custom/function';

const STATE = {

    projects: null,
    project_info: {},
    documents: [],
    to_documents: [],
    hovered_key: null,
    document_notes: [],
    new_proj_id: null,
    project_image: null,
    image_existed: false,
    view_mode: 'card',

}

const GETTERS = {

    projects: state => state.projects,
    project_info: state => state.project_info,
    documents: state => state.documents,
    to_documents: state => state.to_documents,
    hovered_key: state => state.hovered_key,
    document_notes: state => state.document_notes,
    new_proj_id: state => state.new_proj_id,
    project_image: state => state.project_image,
    image_existed: state => state.image_existed,
    view_mode: state => state.view_mode,

}

const MUTATIONS = {

    getProjects(state, projects) {
        state.projects = projects
    },

    getProject(state, project_info) {
        state.project_info = project_info
    },

    getDocumentsInProject(state, documents) {
        state.documents = documents
    },

    getDocumentsInToProject(state, documents) {
        state.to_documents = documents
    },

    setHoveredKey(state, key) {
        state.hovered_key = key
    },

    getDocumentNotes(state, document_notes) {
        state.document_notes = document_notes
    },

    getNewProjId(state, proj_id) {
        state.new_proj_id = proj_id
    },

    getProjectImage(state, payload) {
        state.project_image = payload.image
        state.image_existed = payload.result
    },

    removeProjectImage(state) {
        state.project_image = null
        state.image_existed = false
    },

    setViewMode(state, mode) {
        state.view_mode = mode
    },

    setStar(state, payload) {
        state.documents.filter(v => v.key == payload.key)[0].star = payload.star
    },

    setTags(state, payload) {
        state.documents.filter(v => v.key == payload.key)[0].tags = payload.tags
    },

}

const ACTIONS = {

    async getProjects({ commit }) {
        await axios.ACCESS.get('/api/projects')
            .then(res => {
                // console.log('project/getProjects', res)
                if (res.data.result) {
                    commit('getProjects', res.data.projects)
                } else { throw new Error(res.data) }
            })
    },

    async createProject({ commit, dispatch }, payload) {
        await axios.ACCESS.post('/api/project', payload)
            .then(async(res) => {
                // console.log('project/createProject', res)
                if (res.data.result) {
                    await dispatch('getProjects')
                    commit('getNewProjId', res.data.project.proj_id)
                } else { throw new Error(res.data) }
            })
    },

    async getProjectInfo({ commit, dispatch }, payload) {
        await axios.ACCESS.get('/api/s2/project/' + payload.proj_id + '/info')
            .then(res => {
                // console.log('project/getProjectInfo', res)
                if (res.data.result) {
                    commit('getProject', res.data.project)
                } else { throw new Error(res.data) }

            })
    },

    async getProject({ commit, dispatch }, payload) {
        await axios.ACCESS.get('/api/s2/project/' + payload.proj_id + '/info')
            .then(res => {
                // console.log('project/getProject', res)
                if (res.data.result) {
                    commit('getProject', res.data.project)
                    dispatch('getDocumentsInProject', {
                        proj_id: payload.proj_id
                    })
                } else { throw new Error(res.data) }

            })
    },

    async getDocumentsInProject({ commit }, payload) {
        await axios.ACCESS.get('/api/s2/project/' + payload.proj_id + '/documents')
            .then(res => {
                // console.log('project/getDocumentsInProject', res)
                if (res.data.result) {
                    addIso690(res.data.documents)
                        .then(res => {
                            res.forEach(doc => Object.keys(doc).forEach(k => doc[k] = doc[k] == 'null' ? 'n.r.' : doc[k]))
                            commit('getDocumentsInProject', res)
                        })
                } else { throw new Error(res.data) }
            })
    },

    async getDocumentsInToProject({ commit }, payload) {
        await axios.ACCESS.get('/api/bt/project/' + payload.proj_id + '/documents')
            .then(res => {
                // console.log('project/getDocumentsInToProject', res)
                if (res.data.result) {
                    addIso690(res.data.documents)
                        .then(res => {
                            commit('getDocumentsInToProject', res)
                        })
                } else { throw new Error(res.data) }
            })
    },

    async updateStatus({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/project/' + payload.proj_id, {
                status: payload.status,
            })
            .then(async(res) => {
                // console.log('project/updateStatus', res)
                if (res.data.result) {
                    await dispatch('getProjects')
                } else { throw new Error(res.data) }

            })
    },

    async updateProject({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/project/' + payload.proj_id, {
                title: payload.title,
                description: payload.description,
                status: payload.status,
                mode: payload.mode,
                list_mode: payload.list_mode,
                color: payload.color,
                completed_ts: payload.completed_ts,
                due_date: payload.due_date,
                due_date_null: payload.due_date_null,
            })
            .then(async(res) => {
                // console.log('project/updateProject', res)
                if (res.data.result) {
                    await dispatch('getProject', {
                        proj_id: payload.proj_id
                    })
                    await dispatch('getProjects')
                } else { throw new Error(res.data) }

            })
    },

    async updateProjectListMode({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/project/' + payload.proj_id, {
                list_mode: payload.list_mode
            })
            .then(async(res) => {
                // console.log('project/updateProjectListMode', res)
                if (res.data.result) {
                    await dispatch('getProjectInfo', {
                        proj_id: payload.proj_id
                    })
                } else { throw new Error(res.data) }
            })
    },

    async updateProjectInLab({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/project/' + payload.proj_id, {
                list_mode: payload.list_mode,
            })
            .then(async(res) => {
                // console.log('project/updateProjectInLab', res)
                await dispatch('getProjects')
            })
    },

    async updateProjectNote({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/project/' + payload.proj_id, {
                note: payload.note,
                note_wc: payload.note_wc
            })
            .then(res => {
                // console.log('project/updateProjectNote', res)
            })
    },

    async deleteProject({ dispatch }, payload) {
        await axios.ACCESS.delete('/api/project/' + payload.proj_id)
            .then(res => {
                // console.log('project/deleteProject', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async addCopyDocumentsToProject({ dispatch }, payload) {
        await axios.ACCESS.post('/api/project/' + payload.proj_id + '/documents', {
                documents: payload.documents
            })
            .then(async(res) => {
                // console.log('project/addDocuments', res)
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async addDocumentsToProject({ dispatch }, payload) {
        await axios.ACCESS.post('/api/project/' + payload.proj_id + '/documents', {
                documents: payload.documents
            })
            .then(async(res) => {
                // console.log('project/addDocuments', res)
                await dispatch('getProject', {
                    proj_id: payload.proj_id
                })
                if (!res.data.result) { throw new Error(res.data) }
            })
    },

    async removeDocumentsFromProject({ dispatch }, payload) {
        await axios.ACCESS.put('/api/bt/project/' + payload.proj_id + '/documents', {
                documents: payload.documents
            })
            .then(async(res) => {
                // console.log('project/removeDocuments', res)
                if (!res.data.result) { throw new Error(res.data) }
                await dispatch('getProject', {
                    proj_id: payload.proj_id
                })
            })
    },

    async setStar({ dispatch }, payload) {
        await axios.ACCESS.patch('/api/project/' + payload.proj_id + '/documents', {
                doc_key: payload.doc_key,
                star: payload.star,
                tags: payload.tags,
            })
            .then(async(res) => {
                // console.log('project/setStar', res)
                if (!res.data.result) { throw new Error(res.data) }
                // await dispatch('getProject', {
                //     proj_id: payload.proj_id
                // })
            })
    },

    async getDocumentNotes({ commit }, payload) {
        await axios.ACCESS.get('/api/documentnotes?proj_id=' + payload.proj_id)
            .then(res => {
                // console.log('project/getDocumentNotes', res)
                addIso690(res.data.document_notes)
                    .then(res => {
                        commit('getDocumentNotes', res)
                    })
            })
    },

    async setProjectImage({ commit, dispatch }, payload) {
        await axios.ACCESS.post('/api/project/' + payload.proj_id + '/image', payload.form_data, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then(res => {
                // console.log('project/setProjectImage', res)
                dispatch('getProjectImage', payload.proj_id)
            })
    },

    async getProjectImage({ commit }, id) {
        await axios.ACCESS.get('/api/project/' + id + '/image', {
                responseType: 'arraybuffer',
            })
            .then(res => {
                // console.log('project/getProjectImage', res)
                let project_image = null
                if (res) {
                    let image = btoa(
                        new Uint8Array(res.data)
                        .reduce((data, byte) => data + String.fromCharCode(byte), '')
                    )
                    project_image = `data:${res.headers['content-type'].toLowerCase()};base64,${image}`
                }
                commit('getProjectImage', {
                    image: project_image,
                    result: !!res,
                })
            })
    },

    async deleteProjectImage({ commit, dispatch }, id) {
        await axios.ACCESS.delete('/api/project/' + id + '/image')
            .then(res => {
                // console.log('project/deleteProjectImage', res)
                commit('removeProjectImage')
            })
    },

}

export default {
    namespaced: true,
    state: STATE,
    getters: GETTERS,
    mutations: MUTATIONS,
    actions: ACTIONS,
}


// WEBPACK FOOTER //
// ./src/vuex/modules/project.js